import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Box,
} from '@mui/material';

export default function ConfirmationDialog({
  open,
  title,
  message,
  onConfirm,
  onClose,
  confirmLabel = 'Accept',
  cancelLabel = 'No',
  requiredWord,  // when provided, auto-confirm via Enter is disabled
  showInput,     // when true, always show the input field
}) {
  const [input, setInput] = useState('');

  useEffect(() => {
    if (open) {
      setInput('');
    }
  }, [open]);

  // For requiredWord confirmation, enable button only when the input exactly matches.
  const isConfirmEnabled = requiredWord ? input === requiredWord : true;

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      onKeyDown={(e) => {
        // Only auto-confirm if there's no input field (i.e. neither requiredWord nor showInput)
        if (!showInput && !requiredWord && e.key === 'Enter') {
          onConfirm();
        }
      }}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: { xs: 0, sm: 2 },
          maxHeight: { xs: '90vh', sm: '85vh' },
        },
      }}
    >
      <DialogTitle 
        id="confirmation-dialog-title" 
        sx={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'warning.main' }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
          {message}
        </DialogContentText>
        <Box sx={{ my: 1 }} />
        {(requiredWord || showInput) && (
          <TextField
            autoFocus
            margin="dense"
            fullWidth
            label={requiredWord ? `Type "${requiredWord}" to confirm` : "Template Name"}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            // Only allow Enter auto-confirm when NOT using requiredWord
            onKeyDown={!requiredWord ? (e) => { if (e.key === 'Enter') onConfirm(input); } : undefined}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text" sx={{ color: (theme) => theme.palette.primary.light }}>
          {cancelLabel}
        </Button>
        <Button 
          onClick={() => onConfirm(requiredWord || showInput ? input : undefined)} 
          disabled={requiredWord ? !isConfirmEnabled : false} 
          variant="contained" 
          color="secondary"
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
